<template>
  <div class="trips-page">
    <div class="back-box" @click="back">
      <i class="fas fa-chevron-left fa-fw"></i>
      BACK
    </div>

    <div class="product-header">
      <img :src="view.Images[0]" v-if="view.Images && view.Images.length" class="product-image">
      <div class="product-info">
        <div class="pd-title">{{ view.HotelName }}</div>
        <div class="product-meta">
          <span v-if="view.Address">
            <i class="fas fa-map-marker-alt fa-fw"></i>
            {{ view.Address }}
          </span>
          <!-- <span v-if="tripData.details.ProductCode">
            <i class="fas fa-tags fa-fw"></i>
            Product: {{ tripData.details.ProductCode }}
          </span> -->
        </div>
        <p class="desc">{{ cleanTags(view.Description) }}</p>
      </div>
    </div>

    <div class="section-title">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"></path></svg>
      Choose the perfect room for your stay
    </div>

    <div class="room-card"  v-for="room in rooms.HotelRoomsDetails">
      <div class="room-header">
        <div class="room-title-wrap">
          <div class="room-title">{{ room.RoomTypeName }}</div>
          <div class="room-tags">
            <span :class="['room-tag', {free: am.toLowerCase().includes('free')}]" v-for="am in room.OtherAmennities">{{ am }}</span>
          </div>
        </div>
        <div class="room-price">
          <div class="label">Total Price</div>
          <div class="amount">
            <span class="currency">{{ currencySymbol[currency.code] }}</span>
            {{ applyCurrency(room.Price, false) }}</div>
          <div class="per">per night</div>
          <!-- <div class="tax">+ ₹48 tax</div> -->
        </div>
      </div>
      <!-- <div class="room-details">
        <div class="room-detail">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
          1 Adult
        </div>
        <div class="room-detail">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"></path></svg>
          Twin Bed
        </div>
        <div class="room-detail">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg>
          No Smoking Preference
        </div>
      </div> -->
      <div class="cancel-info" v-if="room.CancellationPolicies && room.CancellationPolicies.length">
        <i class="fas fa-check fa-fw"></i>
        <div class="cancel-text" v-html="cancelPolicy(room.CancellationPolicies)"></div>
        <!-- <strong>Free cancellation</strong> until June 16, 2026. <strong>₹1,013 charge</strong> applies from June 16 onwards. -->
      </div>
      <div class="room-footer">
        <div class="room-meta">Hotel Code: 1514682</div>
        <button class="room-btn" @click="getBlockData(room)">Select Room</button>
      </div>
    </div>

  </div>
</template>

<script>
/* global CONFIG */
import currencySymbol from '@/data/currency.js'
import xcurrency from '@/modules/api/currency'
import moment from 'moment-timezone'

export default {
  name: 'traveller-modal',
  data () {
    return {
      currencySymbol: currencySymbol
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    travellers () { return this.booking.filters.travellers },
    hotel () { return this.$store.state.hotel },
    view () { return this.hotel.view },
    rooms () { return this.hotel.rooms.data },
    locationLabel () {
      if (!this.hotel.location.selected) return ''
      return `${this.hotel.location.selected.destinationName}, ${this.hotel.location.selected.countryName}`
    },
    currency () { return this.$store.state.other.currency }
  },
  methods: {
    back () {
      this.$router.push('/hotel/view')
    },
    cleanTags (x) {
      let parser = new DOMParser()
      return parser.parseFromString(x, 'text/html').body.textContent
    },
    price (data) {
      let price = data.PublishedPrice / this.currency.list[data.CurrencyCode]
      return price.toFixed(2)
    },
    applyCurrency (data, useSymbol = true, noComma = false) {
      let x = data.PublishedPrice
      if (data.Currency !== 'USD' && this.currency.code !== data.CurrencyCode) {
        x = x / this.currency.list[data.CurrencyCode]
        x = x.toString().replace(/[',']/g, '')
        x = parseFloat(x)
        x = x * this.currency.value
      }
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol, noComma)
    },
    cancelPolicy (data) {
      let msg = ''
      let hasFree = false
      let freeIndex = ''
      data.forEach((x, i) => {
        if (x.Charge === 0) {
          hasFree = true
          freeIndex = i
        }
      })
      if (hasFree) {
        msg = `<strong>Free cancellation</strong> until ${this.formatDate(data[freeIndex].ToDate)}. `
        if (data.length > 1) {
          let tmp = data.filter(x => x.Charge !== 0)
          if (!tmp) return msg

          tmp[0].PublishedPrice = tmp[0].Charge
          tmp[0].CurrencyCode = tmp[0].Currency
          msg += `<strong>${this.applyCurrency(tmp[0])} charge</strong> applies between ${this.formatDate(tmp[0].FromDate, true)} and ${this.formatDate(tmp[0].ToDate, true)}.`
          // msg += `<strong>$${this.price(tmp[0])} charge</strong> applies between ${this.formatDate(tmp[0].ToDate, true)} onwards.`
        }
      } else {
        data[0].PublishedPrice = data[0].Charge
        data[0].CurrencyCode = data[0].Currency
        msg = `Cancellation fee of <strong>${this.applyCurrency(data[0])}</strong> applies between ${this.formatDate(data[0].FromDate, true)} and ${this.formatDate(data[0].ToDate, true)}.`
      }
      return msg
    },
    formatDate (x, noYear = false) {
      if (!x) return ''
      let format = noYear ? 'MMMM DD' : 'MMMM DD, YYYY'
      return moment(x, 'YYYY-MM-DD').format(format)
    },
    getBlockData (room) {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})

      // let ageBands = [{bandId: 'ADT', count: this.travellers.adult}]
      // if (self.children) ageBands.push({bandId: 'CHD', count: this.travellers.children})

      self.$sdk.post2(`${CONFIG.d2dAPI}/hotel/block-room`, {
        RoomUniqueId: [room.RoomUniqueId],
        // ResultToken: self.view.first_room_details.Room_data.RoomUniqueId
        ResultToken: self.hotel.selected.ResultToken
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (!r.Status) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.Message
          })
          return
        }
        self.$store.commit('hotel/setRoomsData', {selected: room})
        self.$store.commit('hotel/setData', {block: r.BlockRoom.BlockRoomResult})
        if (!self.$store.state.user.token) {
          self.$store.commit('global/setAuthData', {
            show: true,
            action: '/hotel/review'
          })
          return
        }
        self.$router.push('/hotel/review')
      })
    }
  },
  mounted () {
    this.$store.commit('global/setAuthData', {action: ''})
    if (!this.view) {
      this.$router.push('/search')
      return
    }
  }
}
</script>

<style lang="scss" scoped>
.trips-page{
  padding: 15px 20px;
  margin-bottom: 20px;
  min-height: calc(100vh - 60px);
}
.back-box{
  color: #4a4a6a;
  letter-spacing: .7px;
  margin-bottom: 10px;
  cursor: pointer;
  
  &:hover{
    color: #ff9c09;
  }
}

.product-header {
  display: flex;
  gap: 24px;
  margin-bottom: 32px;
  align-items: flex-start;
}
.product-image {
  width: 180px;
  height: 180px;
  border-radius: 16px;
  object-fit: cover;
  flex-shrink: 0;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}
.product-info {
  flex: 1;

  .pd-title{
    font-size: 26px;
    font-weight: 700;
    color: #1a1a2e;
    margin-bottom: 8px;
    line-height: 1.3;
  }
}
.product-meta {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;

  span{
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 13px;
    color: #8892a0;
    font-weight: 500;

    i{
      color: #ECAE20;
    }
  }
}
.product-info .desc {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 10px;

  svg{
    width: 22px;
    height: 22px;
    color: #ECAE20;
  }
}

.room-card {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 2px solid transparent;
  transition: all 0.25s;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  &:hover{
    border-color: #ECAE20;
    box-shadow: 0 8px 28px rgba(236, 174, 32, 0.12);
}
}
.room-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 14px;
}
.room-title-wrap {
  flex: 1;
}
.room-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 6px;
}
.room-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.room-tag {
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
  background: rgba(107, 114, 128, 0.08);
  color: #4b5563;

  &.free {
    background: rgba(34, 197, 94, 0.08);
    color: #15803d;
  }
}
.room-price {
  text-align: right;
  flex-shrink: 0;

  .label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #b0b8c4;
    margin-bottom: 2px;
  }
  .amount {
    font-size: 28px;
    font-weight: 700;
    color: #1a1a2e;
  }
  .currency {
    font-size: 14px;
    font-weight: 600;
    color: #8892a0;
  }
  .per {
    font-size: 12px;
    color: #b0b8c4;
  }
  .tax {
    font-size: 12px;
    color: #8892a0;
    margin-top: 2px;
  }
}
// .room-details {
//   display: flex;
//   flex-wrap: wrap;
//   gap: 20px;
//   padding: 14px 0;
//   border-top: 1px solid #f1f3f6;
//   border-bottom: 1px solid #f1f3f6;
//   margin-bottom: 16px;
// }
// .room-detail {
//   display: flex;
//   align-items: center;
//   gap: 6px;
//   font-size: 13px;
//   color: #6b7280;
//   font-weight: 500;

//   i{
//     color: #ECAE20;
//   }
// }
.cancel-info {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: rgba(34, 197, 94, 0.06);
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 16px;
  letter-spacing: .4px;

  i{
    color: #22c55e;
  }
  .cancel-text {
    font-size: 13px;
    color: #166534;
    font-weight: 500;
    line-height: 1.5;

    strong {
      color: #15803d;
    }
  }
}
.room-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.room-meta {
  font-size: 12px;
  color: #b0b8c4;
  font-weight: 500;
}
.room-btn {
  padding: 10px 28px;
  background: #ECAE20;
  color: #1a1a2e;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
}
</style>



// WEBPACK FOOTER //
// index.vue?747d1739